module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAABQBAMAAAB8P++eAAAAHlBMVEUAAABPrf9Qr/9OrP/Z7P/d7v/V6v/h8P/S6f/P5//SbfxlAAAAA3RSTlMA40mAJZ3FAAAAv0lEQVRIx+3P4Q2DIBAFYGdoJ+gIjSsoE0hYwBAXMGxAYAPdtq9tTPTOU/GfkSf4Eu6LkeIieT0Ozp9vQdB5uZtUiE+XxSgEI8ynn92E88tuQ+QkjHhG0hwOQ4yYBNoMhvVcF3bYpDnsvLXBek+bQSskwz9sW2UV3svmEOeqsqqizWC1ngwTYV03usHS80YY1Po7xCbNoZA7wF5PLUNjeme0M8vuGXQO5w6LNIdCMvzBUsh5KCXDDHehnAR443wAKb0ZHW6BHq0AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/sub/72.png
// module id = 838
// module chunks = 1